var React = require('react');

function DocumentIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Mask"},React.createElement("path",{"id":"path-1_1_","fill":"#414042","d":"M13.7,3v12H5V5.515l2.55-2.507V3H13.7z M12.425,4.275h-3.9v2.25h-2.25v7.2h6.15V4.275z"})));
}

DocumentIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"18px","height":"18px","viewBox":"0 0 18 18","enableBackground":"new 0 0 18 18","xmlSpace":"preserve"};

module.exports = DocumentIcon;

DocumentIcon.default = DocumentIcon;
